import { attributeRoots, IllustrationRoot, illustrationRoots } from '../services/illustrations';
import { searchFilters } from './publicSearch';

export const illustrationHome = '/?page=illustrations';
export function imageOrigin(params: URLSearchParams): string | null {
    const from = params.get('from');
    if (from === 'favorites') {
        const source = new URLSearchParams({ page: 'favorites' });
        for (const key of ['collection', 'unfiled']) if (params.has(key)) source.set(key, params.get(key)!);
        return '/?' + source;
    }
    if (!from || !from.startsWith('/?')) return null;
    const source = new URLSearchParams(from.slice(2).split('#')[0]);
    if (!source.has('page') && !source.has('view') && from.startsWith('/?#preview-popular-home-')) return from;
    return !source.has('view') && ['illustrations', 'gallery', 'search', 'word', 'color', 'favorites'].includes(source.get('page') || '') &&
        (!source.has('tab') || source.get('tab') === 'gallery') ? from : null;
}
export function resolveIllustrationRoute(search: string): IllustrationRoot | 'home' | 'search' | null {
    let params = new URLSearchParams(search);
    if (params.get('view') === 'image') {
        const origin = imageOrigin(params);
        if (origin) params = new URLSearchParams(origin.slice(2).split('#')[0]);
        else if (params.get('search') !== '1') return 'search';
    }
    const page = params.get('page');
    if (page === 'illustrations') {
        const root = params.get('root') as IllustrationRoot;
        return illustrationRoots.includes(root) ? root : 'home';
    }
    if (page === 'favorites') return 'favorites';
    if (page === 'gallery' && (!params.get('tab') || params.get('tab') === 'gallery') && params.get('search') !== '1') return params.get('root') === 'popular' ? 'popular' : 'recent';
    if (page === 'search' || params.get('search') === '1') {
        const root = params.get('root') as IllustrationRoot;
        if (params.get('root') === 'search') return 'search';
        if ([...attributeRoots, 'rating'].includes(root) && params.has(root)) return root;
        const keys = Array.from(searchFilters(params).keys());
        if (keys.length === 1 && [...attributeRoots, 'rating'].includes(keys[0])) return keys[0] as IllustrationRoot;
        return 'search';
    }
    return ['word', 'color', 'workflow', 'ratings'].includes(page || '') ? 'search' : null;
}
export function illustrationUrl(root: IllustrationRoot, value = '', current?: URLSearchParams): string {
    if (root === 'popular') return '/?page=gallery&root=popular';
    if (root === 'recent') return '/?' + new URLSearchParams({ page: 'gallery', root, ...(value ? { year: value } : {}) });
    if (root === 'favorites') return '/?' + new URLSearchParams({ page: 'favorites', ...(value === 'unfiled' ? { unfiled: '1' } : value ? { collection: value } : {}) });
    if (root !== 'rating' && !value) return '/?' + new URLSearchParams({ page: 'illustrations', root });
    const params = current ? searchFilters(current) : new URLSearchParams();
    params.set('page', 'search'); params.set('root', root); params.set(root, value || '5');
    return '/?' + params;
}

export function keepIllustrationRoot(next: URLSearchParams, previous: URLSearchParams) {
    const root = previous.get('root');
    if (root && [...attributeRoots, 'rating'].includes(root) && next.has(root)) next.set('root', root);
    else if (root) next.set('root', 'search');
    else next.delete('root');
}
